import React from 'react'
import Logo from "../assets/images/logo.png"
// import { LuRefreshCcw } from 'react-icons/lu';



const Navbar = () => {

  // const handleRefresh = () => {
  //   window.location.reload();
  // }
  return (
    <div className='navbar_container'>
      <div className="navbar_item">
        
        <div className="navbar_logo">
          <img src={Logo} alt='logo' />
        </div>
        {/* <div className="refresh_btn">
          <button onClick={handleRefresh}>
            <LuRefreshCcw />
          </button>
        </div> */}
      </div>
    </div>
  )
}

export default Navbar
